export default "__VITE_ASSET__JLdZjhbU__"